export default __webpack_public_path__ + "static/media/roadmap-banner-left.ace71a1f.svg";